import { MAX_TEST_MESSAGE_NUMBERS } from './external-test-messages-creation-request.interface';

/**
 * De-duplicates by phone number and truncates to the MAX_TEST_MESSAGE_NUMBERS send cap.
 *
 * Single source of truth for *which* entries survive the cap, so every layer that holds a
 * selection of test numbers — the portal's dropdown clamp and its send payload guard — can
 * never disagree. `Set` insertion order means the first occurrence of a number wins, and the
 * slice then drops the newest entries, so at the cap a fresh pick is rejected rather than
 * displacing an existing selection.
 *
 * Entries whose number is null/undefined/NaN are dropped rather than occupying a cap slot, so
 * callers do not have to pre-filter to get a well-formed result.
 *
 * @param items - Entries to cap, in selection order
 * @param getNumber - Extracts the phone number a given entry represents
 */
export const capByTestNumber = <T,>(items: T[], getNumber: (item: T) => number | undefined): T[] => {
  const seenNumbers = new Set<number>();

  return items
    .filter((item) => {
      const number = getNumber(item);
      if (number === undefined || number === null || Number.isNaN(number) || seenNumbers.has(number)) {
        return false;
      }
      seenNumbers.add(number);
      return true;
    })
    .slice(0, MAX_TEST_MESSAGE_NUMBERS);
};
